import { Module } from '../utils/_application'

const $ = jQuery

export default class NavigationSearch extends Module {
  ready (app) {
    this.searchBtn = document.querySelector('.mtt-header .search-form')
    this.addSearchClick()
  }

  addSearchClick () {
    if (this.searchBtn) {
      this.searchBtn.addEventListener('click', (e) => {
        this.form = this.searchBtn.querySelector('.form')

        if (this.searchBtn === e.target) {
          this.toggleForm()
        }
      })

      this.clickOutsideOfForm()
    }
  }

  clickOutsideOfForm () {
    window.addEventListener('click', (e) => {
      if (document.querySelector('.form--open')) {
        if (!document.querySelector('.mtt-header .search-form').contains(e.target)) {
          this.removeForm()
        }
      }
    })
  }

  toggleForm () {
    if (!this.form.classList.contains('form--open')) {
      this.form.classList.add('form--open')
      this.form.querySelector('input[type="search"]').focus()
    } else {
      this.form.classList.remove('form--open')
    }
  }

  removeForm () {
    if (this.form.classList.contains('form--open')) {
      this.form.classList.remove('form--open')
    }
  }
}
